import React from "react";

import {
  BsFillTelephoneFill,
} from "react-icons/bs";

import {
  FiMail,
  FiPhone,
  FiUser,
  FiMessageSquare,
} from "react-icons/fi";

import {
  FaMapMarkerAlt,
} from "react-icons/fa";

const Contact = () => {

  const currentYear = new Date().getFullYear();

  return (

    <section className="bg-[#FFF9F4] py-10 overflow-hidden">

      <div className="max-w-6xl mx-auto px-6">

        {/* Heading */}

        <div className="text-center mb-14">

          {/* <div className="inline-block px-6 py-3 rounded-full bg-[#FFE4D6] text-[#FF6B6B] font-semibold">

            🌈 Contact Bhavya Publications

          </div> */}

          <h1 className="text-4xl md:text-6xl font-extrabold text-[#4D96FF] mt-6">

            Let's Learn Together 📚

          </h1>

          <p className="text-gray-600 mt-5 text-lg">

            Have questions about books or publications?

          </p>

        </div>

        {/* Card */}

        <div className="bg-white rounded-[40px] shadow-2xl p-10">

          {/* Contact Cards */}

          <div className="grid md:grid-cols-3 gap-6 mb-12">

            <div className="bg-[#EEF7FF] rounded-3xl p-6 text-center">

              <div className="w-16 h-16 mx-auto rounded-full bg-[#4D96FF] text-white flex items-center justify-center text-2xl mb-4">

                <BsFillTelephoneFill />

              </div>

              <h3 className="font-bold text-xl">

                Call Us

              </h3>

              <p className="mt-2">

                +91-9897901611

              </p>

            </div>

            <div className="bg-[#FFF0F0] rounded-3xl p-6 text-center">

              <div className="w-16 h-16 mx-auto rounded-full bg-[#FF6B6B] text-white flex items-center justify-center text-2xl mb-4">

                <FiMail />

              </div>

              <h3 className="font-bold text-xl">

                Email Us

              </h3>

              <p className="mt-2 break-all">

                bhavyapublications@gmail.com

              </p>

            </div>

            <div className="bg-[#F4FFF0] rounded-3xl p-6 text-center">

              <div className="w-16 h-16 mx-auto rounded-full bg-[#6BCB77] text-white flex items-center justify-center text-2xl mb-4">

                <FaMapMarkerAlt />

              </div>

              <h3 className="font-bold text-xl">

                Visit Us

              </h3>

              <p className="mt-2">

                India - 250002

              </p>

            </div>

          </div>

          {/* Form */}

          <form
            action="https://getform.io/f/96415907-0bf4-4cb3-aea0-79e3a372fa86"
            method="POST"
            className="space-y-5"
          >

            <div className="grid md:grid-cols-2 gap-5">

              <div className="relative">

                <FiUser className="absolute left-4 top-4 text-[#4D96FF]" />

                <input
                  type="text"

                  name="Name"

                  placeholder="Your Name"

                  className="w-full pl-12 p-4 rounded-2xl border bg-[#FFF9F4] outline-none"
                />

              </div>

              <div className="relative">

                <FiMail className="absolute left-4 top-4 text-[#FF6B6B]" />

                <input
                  type="email"

                  name="Email"

                  placeholder="Your Email"

                  className="w-full pl-12 p-4 rounded-2xl border bg-[#FFF9F4] outline-none"
                />

              </div>

            </div>

            <div className="relative">

              <FiPhone className="absolute left-4 top-4 text-[#6BCB77]" />

              <input
                type="text"

                name="Phone"

                placeholder="Your Phone"

                className="w-full pl-12 p-4 rounded-2xl border bg-[#FFF9F4] outline-none"
              />

            </div>

            <div className="relative">

              <FiMessageSquare className="absolute left-4 top-5 text-[#9B5DE5]" />

              <textarea
                rows="5"

                name="Message"

                placeholder="Write your message..."

                className="w-full pl-12 p-4 rounded-2xl border bg-[#FFF9F4] outline-none resize-none"
              />

            </div>

            <button
              type="submit"

              className="w-full py-4 rounded-full bg-gradient-to-r from-[#4D96FF] via-[#9B5DE5] to-[#FF6B6B] text-white font-bold hover:scale-105 transition duration-300"
            >

              🚀 Send Message

            </button>

          </form>

          {/* Bottom */}

          <div className="mt-12 text-center">

            <h3 className="text-2xl font-bold text-[#FF6B6B]">

              🌈 Learn • Play • Grow

            </h3>

            {/* <p className="text-gray-500 mt-2">

              © {currentYear} Bhavya Publications

            </p> */}

          </div>

        </div>

      </div>

    </section>

  );
};

export default Contact;